export enum PdfType {
    PdfFinished = 'PdfFinished',
    PdfRequested = 'PdfRequested',
    DisablePdfButton = 'DisablePdfButton',
    EnablePdfButton = 'EnablePdfButton',
    FilterValuesChanged = 'FilterValuesChanged',
    FilterValueSelected = 'FilterValueSelected',
}

export interface PdfFinishedAction {
    type: PdfType.PdfFinished;
}

export interface PdfRequestedAction {
    type: PdfType.PdfRequested;
}

export interface DisablePdfButtonAction {
    type: PdfType.DisablePdfButton;
}

export interface EnablePdfButtonAction {
    type: PdfType.EnablePdfButton;
}

export interface FilterValuesChangedAction {
    type: PdfType.FilterValuesChanged;
    filterValues: string[];
}

export interface FilterValueSelectedAction {
    type: PdfType.FilterValueSelected;
    selection: string;
}

export const pdfFinished = (): PdfFinishedAction => ({
    type: PdfType.PdfFinished,
});

export const pdfRequested = (): PdfRequestedAction => ({
    type: PdfType.PdfRequested,
});

export const disablePdfButton = (): DisablePdfButtonAction => ({
    type: PdfType.DisablePdfButton,
});

export const enablePdfButton = (): EnablePdfButtonAction => ({
    type: PdfType.EnablePdfButton,
});

export const filterValuesChanged = (filterValues: string[]): FilterValuesChangedAction => ({
    type: PdfType.FilterValuesChanged,
    filterValues,
});

export const filterValueSelected = (selection: string): FilterValueSelectedAction => ({
    type: PdfType.FilterValueSelected,
    selection,
});

export type PdfActionTypes =
    | PdfFinishedAction
    | PdfRequestedAction
    | DisablePdfButtonAction
    | EnablePdfButtonAction
    | FilterValuesChangedAction
    | FilterValueSelectedAction;
